import { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import { PAUSE_REASONS } from '@nu/shared';
import { pauseJob } from './progress.js';

// Pop-up to pause a job part way through and come back to it later
// (waiting for the tipper, materials...): why (Other needs words). Everything
// done so far stays on the job; it goes to the end of the day's jobs and the
// team can start another. The supervisor gets a push.
export default function PauseJob({ day, job, onClose }) {
  const ref = useRef(null);
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  useEffect(() => {
    ref.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const ready = reason && (reason !== 'Other' || note.trim());
  const sup = job.supervisor;

  return (
    <div className="popup-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="popup" role="dialog" aria-modal="true" aria-labelledby="pause-title" tabIndex={-1} ref={ref}>
        <button type="button" className="popup-x" aria-label="Close" onClick={onClose}><X size={20} aria-hidden="true" /></button>
        <p className="popup-kicker">{job.reference} · Pause job</p>
        <h2 id="pause-title" className="popup-title">{[job.addressLine1, job.postcode].filter(Boolean).join(', ')}</h2>
        <p className="popup-note">Why are you pausing it?</p>
        <div className="reason-chips" role="radiogroup" aria-label="Why?">
          {PAUSE_REASONS.map((r) => (
            <button key={r} type="button" role="radio" aria-checked={reason === r} className={`chip${reason === r ? ' on' : ''}`} onClick={() => setReason(r)}>{r}</button>
          ))}
        </div>
        <label className="popup-field">
          <span>{reason === 'Other' ? <>Reason for Other <span className="req">(required)</span></> : <>Note <span className="muted">(optional)</span></>}</span>
          <input className="popup-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Tipper booked for 2pm" maxLength={200} />
        </label>
        <button type="button" className="btn primary popup-btn" disabled={!ready} onClick={() => { pauseJob(day, job, reason, note.trim() || null); onClose(); }}>Pause job</button>
        <p className="small muted popup-sub">Everything done so far is kept. It goes to the end of today&apos;s jobs, so you can start another. {sup ? sup.name : 'Your supervisor'} is told. Tap On route when you head back.</p>
        <button type="button" className="btn popup-btn popup-cancel" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
